// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"2f85a82d","760":"6f4e48b5","787":"352bc4a2","994":"a12ad84f"}[chunkId] + ".chunk.js";
};